// extracted by mini-css-extract-plugin
export var contrastLow = "_3y-1";
export var externalLink = "_3y-2";
export var externalLinkIcon = "_3y-3";
export var link = "_3y-0";
export var linkLabel = "_3y-4";